import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import DonutCustomLegend from '../../../components/ApexCharts/CustomLegends/DonutCustomLegend';
import DonutChart from '../../../components/ApexCharts/DonutChart';
import Button from '../../../components/Button';
import ModalHeader from '../../../components/ModalHeader/ModalHeader';
import Tabs from '../../../components/Tabs/Tabs';
import { DateFormats, formatDate } from '../../../utils/utils';
import CompensationTab from './totalRewardsTabs/CompensationTab';
import EquityTab from './totalRewardsTabs/EquityTab';
import HealthAndWelfareTab from './totalRewardsTabs/HealthAndWelfareTab';
import OtherBenefitsTab from './totalRewardsTabs/OtherBenefitsTab';
import RetirementTab from './totalRewardsTabs/RetirementTab';

const dataCompanyContributions = {
  // The "grid padding - left" setting is a hack to reduce the huge margin to the left that donut renders.
  // See: https://github.com/apexcharts/apexcharts.js/issues/1272
  grid: {
    padding: {
      left: -20,
    },
  },
  legend: {
    show: false,
  },

  dataLabels: {
    enabled: false,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        grid: {
          padding: {
            left: 0,
          },
        },
        legend: {
          show: false,
        },
        title: {},
      },
    },
  ],
  colors: ['#074CBC', '#F48462', '#07B4A0', '#EEA968', '#92E3A9'],
  series: [95072, 15905, 14791, 6500, 0],
  labels: [
    'Compensation',
    'Health and Welfare',
    'Retirement',
    'Equity',
    'Other Benefits',
  ],

  tooltip: {
    enabled: false,
  },

  // DISPLAY TEXT IN DONUT CENTRE:
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          name: {
            offsetY: 10,
          },
          total: {
            show: true,
            showAlways: true,
            fontSize: '18px',
            fontFamily: 'Roboto, Arial, sans-serif',
            fontWeight: 500,
            label: `$132,268`,
            formatter: function (a: any) {
              return '';
            },
          },
        },
      },
    },
  },
};
const tabsData = [
  {
    name: 'Compensation',
    content: <CompensationTab />,
  },

  {
    name: 'Health and Welfare',
    content: <HealthAndWelfareTab />,
  },
  {
    name: 'Retirement',
    content: <RetirementTab />,
  },
  {
    name: 'Equity',
    content: <EquityTab />,
  },
  {
    name: 'Other Benefits',
    content: <OtherBenefitsTab />,
  },
];

export type CompanyContributionModalProps = React.PropsWithoutRef<{
  showCompanyContributionModal: boolean;
  handleCloseCompanyContributionModal: () => void;
}>;

const CompanyContributionModal = ({
  showCompanyContributionModal,
  handleCloseCompanyContributionModal,
}: CompanyContributionModalProps) => {
  return (
    <Modal
      show={showCompanyContributionModal}
      onHide={handleCloseCompanyContributionModal}
      size={'xl'}
    >
      <ModalHeader closeButton={true}>
        <Col>
          <Row>
            {' '}
            <h5>Company's Contribution</h5>
          </Row>
          <Row>
            <span className="text-light-grey text-fs-6 fw-light">
              {`(${formatDate(new Date(), DateFormats.ONLY_YEAR)} Annualized)`}
            </span>
          </Row>
        </Col>
      </ModalHeader>
      <ModalBody>
        <Row className="pt-12 px-lg-0 px-7">
          <Col className="px-0 col-12 col-lg-5">
            <DonutChart
              series={dataCompanyContributions.series}
              options={dataCompanyContributions}
            />
          </Col>
          <Col className="pt-3 lh-xs pe-10 px-lg-10">
            <DonutCustomLegend options={dataCompanyContributions} />
          </Col>
        </Row>
        <Row>
          <Col className="mt-10">
            <Row>
              <Tabs variant="horizontal" tabs={tabsData} />
            </Row>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseCompanyContributionModal}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CompanyContributionModal;
